import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { t } from 'i18next';
import {
  Container,
  Title,
  ScrollBox,
  TermsContent,
  CheckboxContainer,
  CheckboxLabel,
  CheckboxInput,
  CheckboxText,
  RequiredLabel,
  ErrorMessage,
} from './css';

const TermsCheckbox = ({ input, meta }) => {
  const bolTermsUrl = t('BOLTermsUrl');
  const linkText = t('BOLTermsLinkText');
  const beforeLink = t('BOLTermsCheckboxBefore');
  const afterLink = t('BOLTermsCheckboxAfter');

  return (
    <CheckboxContainer>
      <CheckboxLabel>
        <CheckboxInput
          {...input}
          type="checkbox"
          checked={input.value}
        />
        <CheckboxText>
          {beforeLink}
          <a href={bolTermsUrl} target="_blank" rel="noopener noreferrer">
            {linkText}
          </a>
          {afterLink}
        </CheckboxText>
      </CheckboxLabel>
      {meta.touched && meta.error && <ErrorMessage>{meta.error}</ErrorMessage>}
    </CheckboxContainer>
  );
};

TermsCheckbox.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.bool,
    onChange: PropTypes.func,
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

const TermsAndConditions = () => (
  <Container>
    <Title>{t('TermsAndConditionsTitle')}</Title>
    <ScrollBox>
      <TermsContent>
        <h4>{t('BOLTermsMainTitle')}</h4>
        <h4>{t('BOLTermsSection1Title')}</h4>
        <p>{t('BOLTermsSection1Text')}</p>
        <h4>{t('BOLTermsSection2Title')}</h4>
        <p>{t('BOLTermsSection2Text1')}</p>
        <p>{t('BOLTermsSection2Text2')}</p>
        <h4>{t('BOLTermsSection3Title')}</h4>
        <p>{t('BOLTermsSection3Text')}</p>
        <h4>{t('BOLTermsSection4Title')}</h4>
        <p>{t('BOLTermsSection4Text')}</p>
        <h4>{t('BOLTermsSection5Title')}</h4>
        <p>{t('BOLTermsSection5Text')}</p>
      </TermsContent>
    </ScrollBox>
    <RequiredLabel>{t('AcceptTermsAndConditions')}</RequiredLabel>
    <Field
      name="termsAccepted"
      component={TermsCheckbox}
    />
  </Container>
);

export default TermsAndConditions;
